/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAvailableClassResponse } from './GetAvailableClassResponse';
import {
    GetAvailableClassResponseFromJSON,
    GetAvailableClassResponseFromJSONTyped,
    GetAvailableClassResponseToJSON,
    GetAvailableClassResponseToJSONTyped,
} from './GetAvailableClassResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetAvailableClassResponse
 */
export interface PaginatedResultOfGetAvailableClassResponse {
    /**
     * 
     * @type {Array<GetAvailableClassResponse>}
     * @memberof PaginatedResultOfGetAvailableClassResponse
     */
    items?: Array<GetAvailableClassResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetAvailableClassResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAvailableClassResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAvailableClassResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAvailableClassResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetAvailableClassResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetAvailableClassResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetAvailableClassResponse interface.
 */
export function instanceOfPaginatedResultOfGetAvailableClassResponse(value: object): value is PaginatedResultOfGetAvailableClassResponse {
    return true;
}

export function PaginatedResultOfGetAvailableClassResponseFromJSON(json: any): PaginatedResultOfGetAvailableClassResponse {
    return PaginatedResultOfGetAvailableClassResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetAvailableClassResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetAvailableClassResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetAvailableClassResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetAvailableClassResponseToJSON(json: any): PaginatedResultOfGetAvailableClassResponse {
    return PaginatedResultOfGetAvailableClassResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetAvailableClassResponseToJSONTyped(value?: PaginatedResultOfGetAvailableClassResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetAvailableClassResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

